import { createContext, useContext } from "react";
import type { Timeseries } from "../types";

/** Keyed by queryId → columnKey → Timeseries */
export type DwhData = Record<string, Record<string, Timeseries>>;

export interface DwhDataContextType {
  dwhData: DwhData | undefined;
  isLoading: boolean;
  error: string | null;
}

export const DwhDataContext = createContext<DwhDataContextType>({
  dwhData: undefined,
  isLoading: false,
  error: null,
});

export function useDwhData() {
  return useContext(DwhDataContext);
}
